import { ActivityListTypeEnum } from 'src/models/genericActivityList';
import { MailListItem } from 'src/models/mailList';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { MailListCallbackStoreContract } from '../interfaces';

export class GetTheOpenMailModuleMailsForTheUserCallBack extends Callback<MailListItem[]> {
	public constructor(
		private readonly store: MailListCallbackStoreContract,
		private readonly page: number,
		private readonly queryIdentifier: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setListLoadError();
	};

	successCallbackFunction = (
		successResponse: MailListItem[],
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	): void => {
		if (!this.store.isLatestQueryIdentifier(ActivityListTypeEnum.OPEN, this.queryIdentifier)) {
			return;
		}

		this.store.setOpenMailList({
			page: this.page,
			payload: successResponse,
			totalCount: Number(baseRecordSuccessResponse?.totalCount ?? 0),
		});
	};
}
